import { isNull } from "App/utils/helpers";
import { useContext, useState } from "react";
import { useMutation } from "react-query";
import { getAllBarangByKelas } from "../TabBarang/DaftarBarang/helpers";
import { RESET_STATE_FORM_FILTER } from "App/Component/layout/Wms/PerbekalanFarmasi/InventoryControl/DaftarInventoryControl/helpers";
import { FormContext } from "../../context/FormContext";

const refetchBarangByAsuransi = async (variables) => {
  if (
    !isNull(variables.kelasId) &&
    !isNull(variables.asuransiId) &&
    !isNull(variables.gudang_id)
  ) {
    const response = await getAllBarangByKelas(
      {
        gudang_id: variables.gudang_id,
        asuransi_id: variables.asuransiId,
        kelas_id: variables.kelasId,
      },
      {
        barang_name: isNull(variables.barang_name) ? "" : variables.barang_name,
      },
      variables.pages,
      variables.limit
    );
    return {
      data: response.data,
      meta: response.meta,
    };
  } else {
    return {
      data: [],
      meta: {
        count: 0,
        pages: 1,
        limit: 10,
      },
    };
  }
};

export const useDaftarBarangGudang = () => {
  const { formData } = useContext(FormContext);
  const [formFilterBarangByKelas, setFormFilterBarangByKelas] = useState(
    RESET_STATE_FORM_FILTER
  );

  const barangs = useMutation({
    mutationFn: (variables) => {
      return refetchBarangByAsuransi(variables);
    },
  });

  const rowsBarangByKelas = isNull(barangs.data) ? [] : barangs.data.data;
  const totalDataBarangByKelas = isNull(barangs.data)
    ? 0
    : barangs.data.meta.count;
  const loadingBarangByKelas = barangs.isLoading;

  const setNewDataBarangByKelas = (
    pages = formFilterBarangByKelas.pages,
    limit = formFilterBarangByKelas.limit,
    formFilter = formFilterBarangByKelas
  ) => {
    barangs.mutate({
      pages,
      limit,
      barang_name: formFilter.barang_name,
      gudang_id: formData.gudang_id,
      asuransiId: formData.asuransi_id,
      kelasId: formData.kelas_id,
    });
  };

  return {
    loadingBarangByKelas,
    setNewDataBarangByKelas,
    rowsBarangByKelas,
    totalDataBarangByKelas,
    formFilterBarangByKelas,
    setFormFilterBarangByKelas,
  };
};
